import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import Navbar from "./components/Navbar";
import Home from "./components/pages/Home";
import Services from "./components/pages/Services";
import AboutUs from "./components/pages/AboutUs";
import ContactUs from "./components/pages/ContactUs";
import "./App.css";
import { trackOutboundLink } from "./utils/analytics";

// GA4 page view tracking on route changes
const GA_MEASUREMENT_ID = "G-LSMRWZ0FG1";

function useGATrackPageViews() {
  const location = useLocation();
  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const gtag = window.gtag;
    if (typeof gtag !== "function") return;
    gtag("config", GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
    });
  }, [location]);
}

function RoutedApp() {
  useGATrackPageViews();
  React.useEffect(() => {
    const onClick = (e) => {
      const anchor = e.target.closest && e.target.closest('a');
      if (!anchor) return;
      const url = anchor.getAttribute('href');
      const isExternal = url && /^https?:\/\//i.test(url) && !url.includes(window.location.host);
      if (isExternal) {
        trackOutboundLink(url);
      }
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <RoutedApp />
      </Router>
    </ThemeProvider>
  );
}

export default App;
